'use strict';

function NoVideoInputDevicesError() {
  this.name = 'NoVideoInputDevicesError';
  this.message = 'No video input devices found';
}
NoVideoInputDevicesError.prototype = new Error();

module.exports = {
  NoVideoInputDevicesError: NoVideoInputDevicesError
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-qr-reader/lib/errors.js
// module id = 608
// module chunks = 8